import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";
import { motion } from "framer-motion";
import darkLogo from "../assets/status-bot-logo-dark.svg";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4 relative">
      <div className="absolute top-8 left-8">
        <img src={darkLogo} className="h-7 bg-black" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-xl"
      >
        <Card className="border-2 border-destructive/20">
          <CardHeader>
            <div className="flex items-center gap-2">
              <AlertCircle className="h-5 w-5 text-destructive" />
              <CardTitle>Something went wrong</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <div className="text-sm text-muted-foreground space-y-4">
              <p>An error occurred in the application:</p>
              <pre className="mt-2 rounded-lg bg-secondary/50 p-4 font-mono text-xs overflow-auto max-h-[200px]">
                {error.message}
              </pre>
              <p className="text-xs">
                If this issue persists, please contact our support team at
                <Button 
                  variant="link" 
                  className="text-xs h-auto p-0 text-primary hover:underline ml-1"
                  onClick={() => window.location.href = 'mailto:help@status.bot'}
                >
                  help@status.bot
                </Button>
              </p>
            </div>
          </CardContent>
          <CardFooter className="flex justify-end gap-4">
            <Button
              variant="outline"
              onClick={() => window.location.href = '/today'}
            >
              Go to Dashboard
            </Button>
            <Button
              onClick={resetErrorBoundary}
            >
              Try Again
            </Button>
          </CardFooter>
        </Card>
      </motion.div>
    </div>
  );
};

export default ErrorFallback; 